import styled from "styled-components";
import { BREAKPOINTS } from "../../../../../../app/appConstants";

export const ProfileButtonEmailTitleStyled = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: var(--color-secondary);
  
    .color-white {
        color: var(--color-white);
    }
    
    span {
        margin-left: 12px;
    }
`;

export const ProfileButtonEmailLinkSentStyled = styled.div`
    padding: 6px 12px;
    font-weight: 600;
    font-size: 14px;
    color: #9D9EAB;
`;

export const ProfileButtonEmailInfoContainerStyled = styled.div`
    padding: 16px;
    border-radius: 16px;
    width: 100%;
  
    &.bg-gray {
        background: rgba(255, 255, 255, 0.05);
    }
  
    &.bg-surface {
        background: var(--color-surface);
        @media (max-width: ${BREAKPOINTS.small}px) {
            background: #1B1C2D;
        }
    }
  
    p {
        color: var(--icon-primary-color);
        font-size: 12px;
        font-weight: 400;
    }
  
    button {
        &, &:hover, &:focus, &:active {
            border: none;
            color: var(--color-white);
        }
    }
`;